import { useState, useEffect } from "react";
import { supabase } from "@/lib/supabaseClient";
import { Settings, UseSettingsReturn } from "@/types/settings";
import { getSettings } from "@/api/apiSettings";

export function useSettings(): UseSettingsReturn {
  const [settingsData, setSettingsData] = useState<Settings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function loadSettings() {
      try {
        const data = await getSettings();
        setSettingsData(data as Settings);
      } catch (error) {
        setError(error as Error);
      } finally {
        setLoading(false);
      }
    }

    loadSettings();

    // Supabase real-time subscription for settings table
    const channel = supabase
      .channel("settings:realtime")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "settings" },
        (payload) => {
          setSettingsData(payload.new as Settings);
        }
      )
      .subscribe();

    return () => {
      channel.unsubscribe();
    };
  }, []);

  return { settingsData, loading, error };
}
